<template >
  <div name="outcomes" class="inner">
         <div name="innertopbar" class="flex top-bar justify-between pl-2">
        <button class="filter-bar-button" @click="closeWindow()">
          <i class="fas fa-chevron-left " title="Close"></i> Back to {{ course.name }}
      </button>


       <div class="flex pt-2">
               <div>
            <input
              type="search"
              class="filter-bar-search focus:outline-none w-56"
              name="search"
              v-model="search"
              placeholder="Search pupils..."
            />
            <i
              class="fas fa-times text-sm absolute -ml-8 mt-4 cursor-pointer hover:opacity-50"
              @click="clearTags()"
              title="Clear search"
              v-show="search.length > 0"
            ></i>
          </div>
          

                <button class="filter-bar-button" @click="closeWindow()">
          <i class="fas fa-times " title="Close"></i> Close
      </button>
      </div>

      </div>

    <div class="ml-6  mb-6">
            <header class="flex justify-between mt-4 mb-6">
           <div class="flex mb-2">
                    <div class="mr-2 w-16 h-16 p-1 bg-purple-200 bg-opacity-25  rounded-full text-center "> 
                      <i class="fas fa-bullhorn text-3xl text-base text-purple-800 opacity-75  pt-4" title="Overview"></i></div>
                    
                    <div class="pt-2"> 
                       <h3 class="text-xl font-semibold">Unit Pupil Voice</h3>
                      <p class="text-xs pl-1 font-medium ">  Please select a pupil to view pupil voice options.</p>
                    </div>
                      
                    </div>

      </header>



      <transition name="fade">
        <div class="loading" v-show="loading">
          <span class="fa fa-spinner fa-spin"></span> Loading
        </div>
      </transition>

      <div v-if="errored" class="empty">
        <p>
          We are not able to retrieve this information at the moment, please try
          back later
        </p>
      </div>

      <div class="grid grid-cols-4 gap-3 w-full" v-if="componentLoaded && hasAccess">
        <div
          v-for="pupil in pupils"
          :key="pupil.identifer"
          class="content-center center"
        >
          <div
            class="flex flex-col bg-list-grey rounded-lg mb-3 w-full border-l-4 border-r-4 border-solid border-list-grey border-blue-100 border-b-8"
          >
            <div class="w-full font-bold text-blue-500 mb-2 p-2">
              {{ pupil.name }}
            </div>
            <div
              v-for="survey in surveyList"
              :key="survey.identifer"
              class="w-full flex flex-row justify-between bg-white p-2 odd:bg-red-100 cursor-pointer hover:opacity-50"
              @click="selectSurvey(survey, pupil)"
            >
              <div>
                {{ survey.title }}
              </div>
              <i class="fas fa-chevron-right mt-1 mx-2"></i>
            </div>
          </div>
        </div>
      </div>
        <div v-else>
        <UpgradeContent :area="'Assessment'"></UpgradeContent>
      </div>

      <ModalSlide
        :show="showingSurveyView"
        :cssWidth="'md:w-6/12'"
        @closeModal="closeSurveyView()"
      >
        <template v-slot:header-icon>
          <i class="fas fa-poll"></i>
        </template>
        <template v-slot:header-title> {{ title }} </template>
        <template v-slot:body>
          <WellbeingSurveyEntry
            v-if="displaySurvey"
            :course="course"
            :pupil="selectedPupil"
            :survey="selectedSurvey"
            @surveySet="setSurveyComplete"
          ></WellbeingSurveyEntry>

          <div v-else class="pl-4">No surveys available for selected Unit</div>
        </template>
      </ModalSlide>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { WellbeingService } from "@/services/wellbeing.service";

const ModalSlide = () => import("@/components/ModalSlide.vue");
const WellbeingSurveyEntry = () =>
  import("@/components/selfassess/BasicSurveyEntry.vue");
  const UpgradeContent = () => import("@/components/upgrade/UpgradeContent.vue");


export default {
  name: "outcomes",
  props: {
    course: Object,
    pupils: Array,
  },
  computed: {
    ...mapGetters({
      currentUser: "currentUser",
      currentAccess: "currentAccess",
      settings: "settings",
    }),
    componentLoaded() {
      return this.loading == false;
    },
        hasAccess() {
       if (this.currentUser.isOnFree || this.currentUser.isOnLite ) {
            return this.currentAccess.pupilVoiceAccess
       } else {
        return true
       }
    },
    selectAllPupilsTitle() {
      return this.hasSelectAllPupils ? "Deselect All" : "Select All";
    },
    hasSelectedPupil() {
      return (
        (this.selectedPupil != undefined || this.selectedPupil != null) &&
        this.selectedSurvey != undefined
      );
    },
    displaySurvey() {
      return this.showingSurveyView && this.hasSelectedPupil;
    },
    title() {
      if (this.selectedSurvey === undefined) {
        return;
      }
      return "Post Unit " + this.course.name + " - " + this.selectedPupil.name;
    },
    surveyList() {
      return [this.surveys[this.surveys.length - 1]];
    },
  },
  data: function () {
    return {
      errored: false,
      loading: true,
      surveys: [],
      selectedPupil: undefined,
      selectedSurvey: undefined,
      showingSurveyView: false,
      search: "",
    };
  },
  created() {},
  mounted() {
    this.fetchSurveys();
  },
  methods: {
    isSchoolType(outcome) {
      return outcome.type_id === 3;
    },
    fetchSurveys() {
      // fetch surveys
      WellbeingService.getSurveysForUnit(this.course.id)
        .then((response) => (this.surveys = response.data.data))
        .catch((err) => {
          console.log("surveys " + err);
          this.errored = true;
        })
        .finally(() => (this.loading = false));
    },
    setSurveyComplete() {
      this.closeSurveyView()
    },
    selectSurvey(survey, pupil) {
      this.showingSurveyView = true
      this.selectedSurvey = survey
      this.selectedPupil = pupil
    },
    clearSelections() {
      this.selectedPupil = undefined;
      this.selectedSurvey = undefined
    },
    closeSurveyView() {
      this.showingSurveyView = false;
      this.clearSelections();
    },
            closeWindow() {
      this.$router.push({ name: "UnitView" });
    },
  },
  components: {
    ModalSlide,
    WellbeingSurveyEntry,
          UpgradeContent,
  },
};
</script>

<style scoped>
</style>